import { Flex, Image, Box } from '@chakra-ui/react';
import LoginLogo from "@/assets/loginLogo.png";

export default function LoginHero() {
  return (
    <Flex
      w="100%"
      h="100vh"
      overflow="hidden"
      position="relative"
      align="center"
      justify="center"
      bg="#09121C"
    >
      {/* Top-left circle (remains the same) */}
      <Box
        position="absolute"
        top="-200px"
        left="-200px"
        width="471px"
        height="471px"
      >
        <svg width="471" height="471" viewBox="0 0 471 471" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_10_18869)">
            <circle cx="142.5" cy="86.5" r="235.5" fill="#85C872" fillOpacity="0.2"></circle>
          </g>
          <defs>
            <filter id="filter0_f_10_18869" x="-293" y="-349" width="871" height="871" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
              <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_10_18869"></feGaussianBlur>
            </filter>
          </defs>
        </svg>
      </Box>

      {/* Bottom-right ellipse */}
      <Box
        position="absolute"
        bottom="-200px"
        right="-200px"
        width="767px"
        height="768px"
      >
        <svg width="767" height="768" viewBox="0 0 767 768" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_17_13814)">
            <ellipse cx="383.5" cy="384" rx="183.5" ry="184" fill="#85C872" fillOpacity="0.2"></ellipse>
          </g>
          <defs>
            <filter id="filter0_f_17_13814" x="0" y="0" width="767" height="768" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
              <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_17_13814"></feGaussianBlur>
            </filter>
          </defs>
        </svg>
      </Box>

      {/* Center ellipse with path */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="1029px"
        height="1030px"
      >
        <svg width="1029" height="1030" viewBox="0 0 1029 1030" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_17_13790)">
            <ellipse cx="479.5" cy="487" rx="314.5" ry="315" fill="#85C872" fillOpacity="0.15"></ellipse>
            <path d="M793.5 487C793.5 660.694 652.917 801.5 479.5 801.5C306.083 801.5 165.5 660.694 165.5 487C165.5 313.306 306.083 172.5 479.5 172.5C652.917 172.5 793.5 313.306 793.5 487Z" stroke="black"></path>
          </g>
          <defs>
            <filter id="filter0_f_17_13790" x="-35" y="-28" width="1029" height="1030" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
              <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_17_13790"></feGaussianBlur>
            </filter>
          </defs>
        </svg>
      </Box>

      {/* Logo */}
      <Flex
        w="100%"
        position="absolute"
        top="50%"
        left="50%"
        transform="translateY(-50%) translateX(-50%)"
        align="center"
        justify="center"
      >
        <Image src={LoginLogo} width="18.75rem"/>
      </Flex>
    </Flex>
  );
}
